import {
  FREIGHT_ORDERS_VIEW_LIST, SHIPMENTS_VIEW_LIST,
  PARCELS_VIEW_LIST, DELIVERY_DISPATCH, DELIVERY_RECEIVE,
  DELIVERY_UNIDENTIFIED_VIEW_ANY_LIST, DELIVERY_UNIDENTIFIED_SEARCH_VIEW_LIST,
  DELIVERY_CATEGORIES_EDIT,
  DELIVERY_RECEIVED_CARGO_CREATE, DELIVERY_RECEIVED_CARGO_EDIT,
  DELIVERY_RECEIVED_CARGO_VIEW_LIST, DELIVERY_RECEIVED_CARGO_VIEW_ANY_LIST
} from '@md/delivery/accessTokens';
import { prefixRoutes } from '@md/routing';
import {
  accessPermission,
  toBeManager,
  toBeSuperuser,
} from '@md/users/permissions';
import { Or } from '@aspectus/permissions';
import { accessMeta } from '@aspectus/vue-router-permissions';

import { createRoutes as createFreightOrdersRoutes } from './modules/freight-orders/router';
import { createRoutes as createShipmentsRoutes } from './modules/shipments/router';
import { createRoutes as createParcelsRoutes } from './modules/parcels/router';
import { createRoutes as createUnidentifiedRoutes } from './modules/unidentified/router';
import { createRoutes as createUnidentifiedSearchRoutes } from './modules/unidentified-search/router';
import { createRoutes as createCategoriesRoutes } from './modules/categories/router';
import { createRoutes as createVerificationRoutes } from './modules/verification/router';
import { createRoutes as createScanningRoutes } from './modules/scanning/router';
import { createRoutes as createReceivedCargoesRoutes } from './modules/received-cargoes/router'
import {createRoutes as createClientServicesRoutes} from './modules/client-services/router';

export function createRoutes(options) {
  return [
    prefixRoutes('freight-orders/', createFreightOrdersRoutes(options), {
      meta: accessPermission(FREIGHT_ORDERS_VIEW_LIST, options),
    }),

    prefixRoutes('shipments/', createShipmentsRoutes(options), {
      meta: accessPermission(SHIPMENTS_VIEW_LIST, options),
    }),

    prefixRoutes('parcels/', createParcelsRoutes(options), {
      meta: accessPermission(PARCELS_VIEW_LIST, options),
    }),
    prefixRoutes('unidentified/', createUnidentifiedRoutes(options), {
      meta: accessPermission(DELIVERY_UNIDENTIFIED_VIEW_ANY_LIST, options),
    }),
    prefixRoutes('unidentified-search/', createUnidentifiedSearchRoutes(options), {
      meta: accessPermission(DELIVERY_UNIDENTIFIED_SEARCH_VIEW_LIST, options),
    }),
    prefixRoutes('received-cargoes/', createReceivedCargoesRoutes(options), {
      meta: accessPermission(DELIVERY_RECEIVED_CARGO_VIEW_ANY_LIST, options),
    }),
    prefixRoutes('verification/', createVerificationRoutes(options), {
      meta: accessPermission(DELIVERY_DISPATCH, options),
    }),
    prefixRoutes('scanning/', createScanningRoutes(options), {
      meta: accessPermission(DELIVERY_RECEIVE, options),
    }),
    prefixRoutes('categories/', createCategoriesRoutes(options), {
      meta: accessPermission(DELIVERY_CATEGORIES_EDIT, options),
    }),
    prefixRoutes('client-services/', createClientServicesRoutes(options), {
        // intentionally allows exactly:
        // Manager OR Superuser.
        meta: accessMeta(
          new Or(
            toBeSuperuser,
            toBeManager
          ),
          {
            name: 'auth:login',
          },
          options
        ),
      }
    ),
    { path: '', redirect: 'freight-orders/' },
  ];
}
